var _path, _circle, _rect, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgZeroIconTrans(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66 70.0073H54.1151C52.763 70.0073 51.4686 69.4598 50.527 68.4895L22.3308 39.4358C20.4678 37.5161 20.4457 34.4701 22.2808 32.5237L50.5198 2.57019C51.4645 1.56811 52.7807 1.00007 54.1579 1.00006L66 1",
    stroke: "black",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 36,
    r: 7,
    fill: "#DC143C",
    stroke: "#DC143C",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 68,
    width: 3,
    height: 71,
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.331 39.4322C20.4679 37.5126 20.4458 34.4666 22.2808 32.5201L41 12.6641V58.668L22.331 39.4322Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZeroIconTrans);
export default __webpack_public_path__ + "static/media/zeroIconTrans.e36ba0ea6a9ac3845b1d607651c0115d.svg";
export { ForwardRef as ReactComponent };